import { NestedProjectExplorer } from '@tableau/nested-project-explorer';
import { ActivitySpinnerWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { cssClass } from '../../style';
import { useProjects } from '../../uploadContent/utils/ProjectExplorerEffects';

export type LocationInputProps = {
  selectedProjectId: string;
  selectProject: (projectId: string) => void;
}

export const LocationInput = (props: LocationInputProps): JSX.Element => {
  const projectTree = useProjects();
  return <>
    <label>
      {Messages.lensCurationLocation()}
    </label>
    <div className={projectPickerStyle}>
      {projectTree ?
        <NestedProjectExplorer
          topLevelDestinationStatus={'structurally_invalid'}
          projects={projectTree}
          onSelectedProjectChanged={project => props.selectProject(project?.id)}
          initiallySelectedProjectId={props.selectedProjectId}
          selectRowOnExpansion={false}
          keepParentsOfSelectedItemExpanded={false}
          /> :
        <div className={loadingSpinnerStyle}>
          <ActivitySpinnerWidget
            testId={'curation-dialog-location'}
            />
        </div>}
    </div>
  </>;
};

const cssPrefix = 'LensCurationLocationPicker';
const projectPickerStyle = cssClass(cssPrefix, 'projectPicker', {
  position: 'relative',
  height:'200px',
  border: '1px solid',
  borderColor: TabStyles.Colors.F5,
  borderRadius: 1,
  $nest: {
    '&:hover': {
      borderColor: TabStyles.Colors.F9,
    },
  },
});

const loadingSpinnerStyle = cssClass(cssPrefix, 'loadingSpinner', {
  display: 'flex',
  justifyContent: 'space-around',
});
